import React from "react"
import Tilt from "react-parallax-tilt"
import ClickAwayListener from "react-click-away-listener"

const Mission = ({ setOpenMission }) => {
  return (
    <div className="mission-container">
      <ClickAwayListener onClickAway={() => setOpenMission(false)}>
        <div className="misson-wrapper">
          <div className="card-wrapper-mission">
            <h1>Mission</h1>
            <h2>
              This years SOUNDS will be focused on the theme of collaboration.
            </h2>
            <p>
              Often times in local music scenes it seems like many emerging
              artistes or producers see other emerging artistes, producers, and
              brands at their level or below as their competitors. And on the
              other hand those same emerging artistes or producers will do
              anything to collaborate with established artistes, producers, and
              brands. When they finally gets that covetted featured with the
              established artiste, producer or brand sure they may get a boost
              or sometimes not, but the establish artistes or producer always
              get the majority of the benefit. Whether thats from payment or
              getting to be assosiated with a fresh new sound. Music has always
              thrived and evolved because of the collaborative innovation that
              happens between emerging artist, producers, and brands. But today
              collaboration is a tricky goal to achieve because of all the
              mistrust, clout chasing, hating, and general finessing that takes
              place in today's music scene. We wanted to break that dynamic with
              this years event. We'll be exploring the power of collaboration,
              starting with you at this event. We're bringing producers and
              artistes together, to speak on their experience with collaboration
              and even to vent about it's difficulties. During the event there
              will be several moments where you'll get to meet other emerging
              artistes/producers and start collaborations with them right on the
              spot. Get ready to meet new people and create new SOUNDS together.
            </p>
          </div>
        </div>
      </ClickAwayListener>
    </div>
  )
}

export default Mission
